import "./manager-permit.component.scss";

export default {
  template: require('./manager-permit.component.html'),
  bindings: {
    permission: "@vuiPermission",
    class: "@vuiClass"
  },
  transclude: true,
  controller: function (vuiOrganisationManagerPermissions, $auth) {
    'ngInject';

    const self = this;

    this.$onInit = () => {
      $auth.currentUser(_ => {
        if ($auth.isAdmin()) {
          self.permit = true;
        } else {
          vuiOrganisationManagerPermissions.hasPermission(self.permission, permit => self.permit = permit)
        }
      });
    };

  }
};
